export const _ADD               = "WyBCKG6HJTwkiUZX5ZpNkQ==";
export const _EDIT              = "toSmUrXACRgYr0hbFXHsAQ==";
export const _VIEW              = "YC7k21Za3CyM5Arb7jBREw==";
export const _DELETE            = "Nrzd+DczL7TJJ6AykuU4PvCiHes/kLM8g9MDo9vIoqI=";
export const _RECOVER           = "rpZZskBVX51bhwD73rkZPPuuerNIo1RZFZmb+VzAipk=";
export const _LIST              = "ZlxxGkANENbDMiB24bvzSw==";
export const _TRASH             = "Kh+5LeBUROjBE4h/IxDoaQ==";